// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__31BZ9","rootSuccess":"CompleteLink_rootSuccess__1Wil7","rootFailure":"CompleteLink_rootFailure__2o1Zb","isDisabled":"CompleteLink_isDisabled__1QK6P"};